export const getColorBySensor = (type: string, sensor?: string | null): string => {
  if (type === 'CFC') return '#37b4b8';
  if (sensor?.includes('LF')) return '#e342f5';
  if (sensor?.includes('F')) return '#b388ff';
  if (sensor === 'LV') return '#42f5ec';
  if (sensor?.includes('L') || sensor?.includes('G')) return '#00c853';
  return '';
};
